import { render, staticRenderFns } from "./ListTutorial.vue?vue&type=template&id=0f018d7c"
import script from "./ListTutorial.vue?vue&type=script&lang=js"
export * from "./ListTutorial.vue?vue&type=script&lang=js"
import style0 from "./ListTutorial.vue?vue&type=style&index=0&id=0f018d7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports